import { gql } from "@apollo/client";

export const GET_CSO_LIST = gql`
  query cso_list {
    myCsoWishes {
      edges {
        node {
          id
          cso {
            id
            publicInformationScore
            reliabilityScore
            isDissolve
            isPublic
            pk
            name
            activeCountries
            revenueCategory {
              scale
            }
            stakeHolders {
              edges {
                node {
                  name
                }
              }
            }
            homepage
            sdgsImages
            totalActivityFields {
              edges {
                node {
                  name
                }
              }
            }
            csocollaborationneeds {
              countries {
                edges {
                  node {
                    nameJp
                  }
                }
              }
              activityFields {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              stakeholders {
                edges {
                  node {
                    name
                  }
                }
              }
            }
            focusedIssue {
              edges {
                node {
                  title
                }
              }
            }
          }
        }
      }
    }
    myCollaborationStatusesAsSupporter {
      edges {
        node {
          id
          isDone
          readableSupporterStatus
          supporterHasNewMessage
          cso {
            id
            isPublic
            publicInformationScore
            reliabilityScore
            pk
            isDissolve
            activeCountries
            name
            csocollaborationneeds {
              countries {
                edges {
                  node {
                    nameJp
                  }
                }
              }
              activityFields {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
              stakeholders {
                edges {
                  node {
                    name
                  }
                }
              }
            }
            stakeHolders {
              edges {
                node {
                  name
                }
              }
            }
            revenueCategory {
              scale
            }
            homepage
            sdgsImages
            totalActivityFields {
              edges {
                node {
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ALL_ACTIVITY_FIELDS = gql`
  query activity_fields {
    allActivityfields {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_COLLABORATION_NEEDS = gql`
  query collaboration_needs {
    allCollaborationNeeds {
      edges {
        node {
          id
          title
          intId
        }
      }
    }
  }
`;

export const GET_ALL_REVENUE_CATEGORIES = gql`
  query revenue_categories {
    allRevenueCategory {
      edges {
        node {
          id
          scale
        }
      }
    }
  }
`;

export const GET_ORG_RESULT = gql`
  query search_org($context: String!, $first: Int, $after: String) {
    searchOrg(context: $context, first: $first, after: $after) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          isDissolve
          pk
          name
          logoUrl
          homepage
          purpose
          isWished
        }
      }
    }
  }
`;

export const GET_MESSAGE_LIST = gql`
  query cso_list {
    myCsoWishes {
      edges {
        node {
          id
          cso {
            pk
            id
            isPublic
            isDissolve
            name
            revenueCategory {
              scale
            }
            homepage
            sdgsImages
            focusedIssue {
              edges {
                node {
                  title
                }
              }
            }
          }
        }
      }
    }
    myCollaborationStatusesAsSupporter {
      edges {
        node {
          id
          interviewDetail {
            decidedInterviewDate
            url
          }
          readableSupporterStatus
          supporterHasNewMessage

          csoStatusIsDone
          cso {
            id
            publicInformationScore
            reliabilityScore
            isPublic
            isDissolve
            name
            pk
            revenueCategory {
              scale
            }
            homepage
            sdgsImages
            totalActivityFields {
              edges {
                node {
                  name
                }
              }
            }
          }
        }
      }
    }
    allSupporters {
      edges {
        node {
          id
        }
      }
    }
  }
`;

export const GET_COLLABORATION_AS_CSO = gql`
  query get_my_collaboration_status_as_cso {
    getMyCollaborationStatusesAsCso {
      edges {
        node {
          readableCsoStatus
          interviewDetail {
            decidedInterviewDate
            url
          }
          id
          csoStatusIsDone
          csoHasNewMessage
          supporter {
            name
            homepageUrl
          }
        }
      }
    }
  }
`;

export const GET_MESSAGE_AS_SUPPORTER = gql`
  query get_message_as_supporter($collaborationStatus: ID!) {
    myCollaborationStatusesAsSupporter(
      collaborationStatusId: $collaborationStatus
    ) {
      edges {
        node {
          cso {
            name
          }
        }
      }
    }
    getMyMessages(collaborationStatus: $collaborationStatus) {
      edges {
        node {
          message
          readAt
          supporterIsSender
          createdAt
          collaborationStatus {
            id
            supporterStatus
            supporter {
              name
              logoUrl
            }
            cso {
              name
              logoUrl
            }
          }
        }
      }
    }
  }
`;

export const GET_MESSAGE_AS_CSO = gql`
  query get_message_as_cso($collaborationStatus: ID!) {
    myCollaborationStatusesAsSupporter(
      collaborationStatusId: $collaborationStatus
    ) {
      edges {
        node {
          supporter {
            name
            logoUrl
          }
        }
      }
    }
    getMyMessagesAsCso(collaborationStatus: $collaborationStatus) {
      edges {
        node {
          message
          readAt
          supporterIsSender
          createdAt
          collaborationStatus {
            id
            csoStatus
            supporter {
              name
              logoUrl
            }
            cso {
              name
              logoUrl
            }
          }
        }
      }
    }
  }
`;

export const GET_LIST_MESSAGE_AS_CSO = gql`
  query get_my_collaboration_status_as_cso {
    getMyCollaborationStatusesAsCso {
      edges {
        node {
          readableCsoStatus
          interviewDetail {
            decidedInterviewDate
            url
          }
          id
          csoStatusIsDone
          csoHasNewMessage
          supporter {
            id
            isPublic
            name
            homepageUrl
          }
        }
      }
    }
  }
`;

export const GET_COMPARISON_DATA = gql`
  query compare_cso($csoIdList: [ID!]!) {
    compareCsoData(csoIdList: $csoIdList) {
      data
    }
  }
`;

export const GET_CSO_WISH_DATA = gql`
  query cso_wish_data($csoId: ID!) {
    myCsoWishes(cso: $csoId) {
      edges {
        node {
          id
        }
      }
    }
  }
`;

export const GET_SUPPORTER_INFO = gql`
  query my_supporter_info {
    mySupporterInfo {
      edges {
        node {
          focusedSdges {
            edges {
              node {
                id
                title
              }
            }
          }
          interestingActivity {
            edges {
              node {
                id
                name
              }
            }
          }
          focusedStakeholders {
            edges {
              node {
                id
                name
              }
            }
          }
          collaborationNeeds {
            edges {
              node {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;
export const GET_COLLABORATION_STATUS = gql`
  query get_colloration_status($collaborationStatus: ID!) {
    getCollaborationStatus(collaborationStatusId: $collaborationStatus) {
      edges {
        node {
          csoStatus
          idealStartingTime
          collaborationScale
          cso {
            csocollaborationneeds {
              collaborationNeeds {
                edges {
                  node {
                    title
                  }
                }
              }
            }
          }
          supporterStatus
          idealStartingTime
          collaborationScale
          collaborationNeeds {
            edges {
              node {
                title
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_MESSAGE_DETAIL_AS_CSO = gql`
  query get_colloration_status($collaborationStatus: ID!) {
    myCollaborationStatusesAsSupporter(
      collaborationStatusId: $collaborationStatus
    ) {
      edges {
        node {
          supporter {
            name
          }
        }
      }
    }
    getCollaborationStatus(collaborationStatusId: $collaborationStatus) {
      edges {
        node {
          csoStatus
          supporterStatus
          idealStartingTime
          collaborationScale
          collaborationNeeds {
            edges {
              node {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;

export const FETCH_INTERVIEW_INVITATION = gql`
  query get_interview_data($collaborationStatusId: ID!) {
    getMyInterviewInvitations(collaborationStatus: $collaborationStatusId) {
      edges {
        node {
          id
          candidateDate1
          candidateDate2
          candidateDate3
          candidateDate4
          candidateDate5
          message
          url
          tool
        }
      }
    }
  }
`;

export const GET_ALL_SEARCH_CSO_LOG = gql`
  query allSearchCsoLog {
    allSearchCsoLog {
      edges {
        node {
          id
          title
          createdAt
          memo
          country
          freeWord
          sdgs {
            edges {
              node {
                id
              }
            }
          }
          activityFields {
            edges {
              node {
                id
              }
            }
          }
          collaborationNeeds {
            edges {
              node {
                id
              }
            }
          }
          targets {
            edges {
              node {
                id
              }
            }
          }
          revenueCategory {
            edges {
              node {
                id
              }
            }
          }
          networks {
            edges {
              node {
                id
              }
            }
          }
          thirdPartyCertifications {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_MEMBERS_LIST = gql`
  query mySupporterRole {
    mySupporterRole {
      edges {
        node {
          id
          permission
          user {
            id
            firstName
            lastName
            email
            additionalInfo {
              username
            }
          }
        }
      }
    }
  }
`;

export const GET_SUPPORTER_CONTRACT = gql`
  query getContract {
    myContractInfo {
      edges {
        node {
          id
          stripeCustomerId
          plan {
            id
            name
            fee
          }
        }
      }
    }
  }
`;
